var map = {
	"./Logo.png": "5684",
	"./LogoAdriatic.png": "be86",
	"./LogoChallenge.png": "e320",
	"./LogoDark.png": "e69d",
	"./Logo_trasp copia.png": "8678",
	"./Logo_trasp.png": "65e5",
	"./_Logo.png": "93a4",
	"./ari.png": "6d66",
	"./cavallo copia.png": "f064",
	"./cavallo.png": "2020",
	"./default.png": "6bcd",
	"./dr-icon.png": "2068",
	"./drone.png": "7a6f",
	"./eu copia.png": "0dcd",
	"./eu.png": "1f23",
	"./eu2.png": "5ba5",
	"./heartbe-icon-red.png": "a85c",
	"./heartbe-icon-white.png": "47fd",
	"./logoEurope.png": "165f",
	"./logoRacehard.png": "aedc",
	"./logo_icron_2.0.png": "52d2",
	"./logo_icron_2.0_bianco.png": "1e1e",
	"./logo_icron_bianco.png": "5aa7",
	"./menumobile.png": "aa8d",
	"./spacer.png": "8905"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "64a2";